export default "__VITE_ASSET__DKUH0HVS__"